
/* -------------------------------------

	Footer

------------------------------------- */

$(document).ready(function() {

	
	$('footer nav.mobile >ul >li a').click(function() {

		var current = $(this).siblings('nav.expand');

		if(current.hasClass('active')) {

			current.parent().removeClass('active');
			current.removeClass('active');
			current.find('ul >li').removeClass('active');

			return false;

		}

		$('footer nav.mobile >ul >li').removeClass('active');
		$('footer nav.expand').removeClass('active');

		$(this).parent().toggleClass('active');
		$(this).siblings('nav.expand').toggleClass('active');

	});

});


